import { Link } from "@inertiajs/react"

export default function AppLogo() {
  return (
    <Link
      href="/"
      className="cursor-pointer transition-opacity hover:opacity-80"
      style={{
        fontSize: "var(--font-size-5)",
        fontWeight: "var(--font-weight-semibold)",
        color: "var(--accent-12)",
        textDecoration: "none",
      }}
    >
      Foodmark
    </Link>
  )
}
